<app-date-filter [filter]="filter" [dataToView]="dataToView">
</app-date-filter>
